module.exports = __webpack_public_path__ + "img/ic-lego.175ceff0.svg";